// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, colorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.purple700;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.white;
  return {
          backgroundColor: backgroundColor,
          color: color
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
